'use strict';

var _ = require('lodash');
var SearchCriteriaFactory = function SearchCriteriaFactory(Rule) {
  function SearchCriteria(params) {
    this.id = params.id;
    this.context = params.context;
    this.name = params.name;
    this.customSearchMode = params.customSearchMode;
    this.rules = _.transform(params.rules, function (result, rule) {
      rule.searchContext = rule.searchContext || params.context;
      result.push(new Rule(rule));
    }, []);
  }
  SearchCriteria.prototype.addRule = function (rule) {
    rule.searchContext = rule.searchContext || this.context;
    this.rules.push(rule);
    return rule;
  };
  SearchCriteria.prototype.removeByIndex = function (index) {
    this.rules.splice(index, 1);
  };
  SearchCriteria.prototype.filterOut = function (filterFunction) {
    this.rules = _.reject(this.rules, filterFunction);
  };
  SearchCriteria.prototype.isValid = function () {
    return !_.isEmpty(this.rules) && _.every(this.rules, function (rule) {
      return rule.isValid();
    });
  };
  return SearchCriteria;
};
SearchCriteriaFactory.$inject = ['SearchCriteriaRuleFactory'];
module.exports = SearchCriteriaFactory;